import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import user from './modules/user';
import tagsView from './modules/tagsView';
import permission from './modules/permission';
import customer from './modules/customer';
import compete from './modules/compete';
import attendance from './modules/attendance';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    tagsView,
    permission,
    customer,
    compete,
    attendance,
  },
  getters,
});

export default store;
